<template>
  <div class="my-security-setting">
    <div ref="securityTitle" class="titile">{{ $t('安全设置') }}</div>
    <div ref="securityContent" class="security-content">
      <!-- 切换修改密码或手机号 -->
      <div class="tabs">
        <div class="tabs-box" :class="tabs_type == 0 ? 'tabs-box-ok' : ''" @click="onSecurityTab(0)">{{ $t('修改密码') }}</div>
        <div class="tabs-box" :class="tabs_type == 1 ? 'tabs-box-ok' : ''" @click="onSecurityTab(1)">{{ $t('修改手机号') }}
        </div>
      </div>
      <!-- 旧密码修改密码或手机号修改密码 -->
      <div class="tag" v-if="tabs_type == 0">
        <div class="tag-box" :class="tag_type == 0 ? 'tag-box-ok' : ''" @click="onPasswordMethod(0)">{{ $t('旧密码修改') }}</div>
        <div class="tag-box" :class="tag_type == 1 ? 'tag-box-ok' : ''" @click="onPasswordMethod(1)">{{ $t('手机验证码修改') }}</div>
      </div>
      <!-- 修改密码 -->
      <div v-if="tabs_type == 0">
        <!-- 旧密码修改密码 -->
        <div class="amend" v-if="tag_type == 0">
          <div class="amend-box">
            <div class="amend-box-left"><span class="text-FF0000">*</span>{{ $t('旧密码') }}</div>
            <input type="text" :placeholder="$t('请输入')" class="amend-box-ipt" v-model="former_amend.old_password">
          </div>
          <div class="amend-box">
            <div class="amend-box-left"><span class="text-FF0000">*</span>{{ $t('新密码') }}</div>
            <input type="text" :placeholder="$t('请输入')" class="amend-box-ipt" v-model="former_amend.password">
          </div>
          <div class="amend-box">
            <div class="amend-box-left"><span class="text-FF0000">*</span>{{ $t('确认密码') }}</div>
            <input type="text" :placeholder="$t('请输入')" class="amend-box-ipt" v-model="former_amend.repeat_password">
          </div>
        </div>
        <!-- 验证码修改密码 -->
        <div class="amend" v-if="tag_type == 1">
          <div class="amend-box">
            <div class="amend-box-left"><span class="text-FF0000">*</span>{{ $t('手机号') }}</div>
            <div class="amend-box-right">
              <div>{{ phone_amend.mobile }}</div>
            </div>
            <!-- <input type="text" :placeholder="$t('请输入')" class="amend-box-ipt" v-model="phone_amend.mobile"> -->
          </div>
          <div class="amend-box">
            <div class="amend-box-left"><span class="text-FF0000">*</span>{{ $t('验证码') }}</div>
            <div class="amend-box-right">
              <input type="text" :placeholder="$t('请输入')" v-model="phone_amend.code">
              <captcha-fetch @onCode="onPhoneCode" ref="phoneCode"></captcha-fetch>
            </div>
          </div>
          <div class="amend-box">
            <div class="amend-box-left"><span class="text-FF0000">*</span>{{ $t('新密码') }}</div>
            <input type="text" :placeholder="$t('请输入')" class="amend-box-ipt" v-model="phone_amend_password">
          </div>
          <div class="amend-box">
            <div class="amend-box-left"><span class="text-FF0000">*</span>{{ $t('确认密码') }}</div>
            <input type="text" :placeholder="$t('请输入')" class="amend-box-ipt" v-model="phone_amend_repeat_password">
          </div>
        </div>
      </div>
      <!-- 修改手机号 -->
      <div class="amend" v-if="tabs_type == 1">
        <div class="amend-box">
          <div class="amend-box-left">{{ $t('手机号') }}</div>
          <div class="amend-box-right">
            <div>{{ former_phone.mobile }}</div>
          </div>
        </div>
          <div class="amend-box amend-box-with-btn">
            <div class="amend-box-left"><span class="text-FF0000">*</span>{{ $t('验证码') }}</div>
            <div class="amend-box-right">
              <input type="text" :placeholder="$t('请输入')" v-model="former_phone.code" :disabled="isVerify">
              <captcha-fetch @onCode="onPhoneCodeOne" ref="phoneCodeOne"></captcha-fetch>
            </div>
            <div class="amend-box-btn" @click="onVerify">{{ $t('校验') }}</div>
          </div>
        <div class="amend-box amend-box-phone">
          <div class="amend-box-left"><span class="text-FF0000">*</span>{{ $t('新手机号') }}</div>
          <div class="amend-box-phone-row">
            <el-dropdown @command="prefixHandleCommand" class="amend-box-prefix">
              <span class="el-dropdown-link">
                +{{ prefix }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="item.name" v-for="(item, index) in prefix_list" :key="index">
                  {{ item.name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <input type="text" :placeholder="$t('请输入')" class="amend-box-ipt amend-box-phone-input" v-model="new_phone.mobile">
          </div>
        </div>
        <div class="amend-box">
          <div class="amend-box-left"><span class="text-FF0000">*</span>{{ $t('新验证码') }}</div>
          <div class="amend-box-right">
            <input type="text" :placeholder="$t('请输入')" v-model="new_phone.code">
            <captcha-fetch @onCode="onPhoneCodeTwo" ref="phoneCodeTwo"></captcha-fetch>
          </div>
        </div>
      </div>

      <div class="btn" @click="onConfirm">{{ $t('确定') }}</div>
    </div>
  </div>
</template>

<style scoped>
div /deep/ .u-text {
  font-size: 14px;
}
</style>

<script>
import CaptchaFetch from '@/components/CaptchaFetch'
// import {  } from '@/api/user';
import { formerAmendPassword, mobileAmendPassword, getCode, changeAccount, verifyCode } from '@/api/login';
import { phonePrefix } from '@/api/user';

export default {
  name: "Securitysetting",
  components: {
    'captcha-fetch': CaptchaFetch,
  },
  data() {
    return {
      ruleForm: {},
      tabs_type: 0,//标签索引
      tag_type: 0,//修改方式索引
      former_amend: {
        old_password: '',//旧密码
        password: '',//新密码
        repeat_password: '',//重复新密码
      },//旧密码修改密码
      phone_amend: {
        mobile: '',//手机号
        code: '',//验证码
        type: 2,//1=注册(未注册手机号),2=忘记密码(已经注册的手机号),3=短信登录,4修改手机号5绑定手机号
      },//手机号修改密码
      phone_amend_password: '',//手机号修改新密码
      phone_amend_repeat_password: '',//手机号修改确认新密码
      former_phone: {
        mobile: '',
        code: ''
      },//旧手机号
      new_phone: {
        mobile: '',
        code: '',
      },//新手机号
      isVerify: false,//是否校验旧手机号
      prefix_list: [],//前缀列表
      prefix: '',//前缀
      // 安全设置页面入场动画实例，用于组件销毁时释放动画资源
      securityEntranceAnimation: null,
    };
  },
  mounted() {
    let user_info = JSON.parse(this.$cookies.get('user_info'))
    this.phone_amend.mobile = user_info.mobile
    this.former_phone.mobile = user_info.mobile
    this.onPhonePrefix();
    // console.log(this.phone_amend.mobile);
    this.$nextTick(() => {
      this.playSecurityEntranceAnimation();
    });
  },
  beforeDestroy() {
    if (this.securityEntranceAnimation) {
      this.securityEntranceAnimation.progress(1).kill();
    }
  },
  methods: {
    /** 播放安全设置页面的入场动效 */
    playSecurityEntranceAnimation() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }
      if (this.securityEntranceAnimation) {
        this.securityEntranceAnimation.progress(1).kill();
      }
      const targets = [this.$refs.securityTitle, this.$refs.securityContent].filter(Boolean);
      this.securityEntranceAnimation = this.$gsap.fromTo(targets, {
        y: 16,
        opacity: 0,
      }, {
        y: 0,
        opacity: 1,
        duration: 0.45,
        stagger: 0.1,
        ease: 'power2.out',
        onComplete: () => {
          this.$gsap.set(targets, { clearProps: 'opacity,transform' });
        },
      });
    },
    /** 切换安全设置主标签并播放内容动效 */
    onSecurityTab(type) {
      this.tabs_type = type;
      this.$nextTick(() => {
        this.playSecurityEntranceAnimation();
      });
    },
    /** 切换密码修改方式并播放内容动效 */
    onPasswordMethod(type) {
      this.tag_type = type;
      this.$nextTick(() => {
        this.playSecurityEntranceAnimation();
      });
    },
    /**前缀切换 */
    prefixHandleCommand(e) {
      // console.log(e);
      this.prefix = e
    },
    /**手机号前缀 */
    onPhonePrefix() {
      phonePrefix().then(res => {
        this.prefix_list = res.data
        this.prefix = this.prefix_list[0].name
        console.log(res.data);
      })
    },
    /**校验 */
    onVerify() {
      if (!this.former_phone.code) {
        this.$message.warning(this.$t('请输入旧手机号验证码'));
        return
      }
      let data = {
        mobile: this.former_phone.mobile,
        code: this.former_phone.code,
        type: 6,
      }
      verifyCode(data).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t('校验成功'));
          this.isVerify = true
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
    /**修改手机号 */
    onAmendMobile() {
      if (!this.isVerify) {
        this.$message.warning(this.$t('请先校验手机号'));
        return
      }
      if (!this.new_phone.mobile) {
        this.$message.warning(this.$t('请输入新手机号'));
        return
      }
      if (!this.new_phone.code) {
        this.$message.warning(this.$t('请输入新手机号验证码'));
        return
      }

      let data = {
        mobile: this.new_phone.mobile,
        code: this.new_phone.code,
        type: 7,
        prefix: this.prefix,
      }
      changeAccount(data).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t('修改成功'));
          this.former_phone.code = '';
          this.new_phone.mobile = '';
          this.new_phone.code = '';
          this.isVerify = false;
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
    /**手机号验证码修改 */
    onMobileAmendPassword() {
      let user_info = JSON.parse(this.$cookies.get('user_info'))

      if (!this.phone_amend.mobile) {
        this.$message.warning(this.$t('请输入手机号'));
        return
      }
      if (!this.phone_amend.code) {
        this.$message.warning(this.$t('请输入验证码'));
        return
      }
      if (!this.phone_amend_password) {
        this.$message.warning(this.$t('请输入新密码'));
        return
      }
      if (!this.phone_amend_repeat_password) {
        this.$message.warning(this.$t('请再次输入新密码'));
        return
      }
      if (this.phone_amend_password != this.phone_amend_repeat_password) {
        this.$message.warning(this.$t('请确认两次密码相同'));
        return
      }

      this.phone_amend.password = this.phone_amend_repeat_password

      mobileAmendPassword(this.phone_amend).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t('修改成功'));
          this.phone_amend = {
            mobile: user_info.mobile,//手机号
            code: '',//验证码
            type: 2,//1=注册(未注册手机号),2=忘记密码(已经注册的手机号),3=短信登录,4修改手机号5绑定手机号
          }
          this.phone_amend_password = ''
          this.phone_amend_repeat_password = ''
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
    /**旧密码修改 */
    onFormerAmendPassword() {
      if (!this.former_amend.old_password) {
        this.$message.warning(this.$t('请输入旧密码'));
        return
      }
      if (!this.former_amend.password) {
        this.$message.warning(this.$t('请输入新密码'));
        return
      }
      if (!this.former_amend.repeat_password) {
        this.$message.warning(this.$t('请再次输入新密码'));
        return
      }
      if (this.former_amend.password != this.former_amend.repeat_password) {
        this.$message.warning(this.$t('请确认两次密码相同'));
        return
      }

      formerAmendPassword(this.former_amend).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t('修改成功'));
          this.former_amend = {
            old_password: '',//旧密码
            password: '',//新密码
            repeat_password: '',//重复新密码
          }
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
    /**确定 */
    onConfirm() {
      if (this.tabs_type == 0) {
        if (this.tag_type == 0) {
          this.onFormerAmendPassword()
        } else {
          this.onMobileAmendPassword()
        }
      } else {
        this.onAmendMobile()
      }
    },
    /**获取手机验证码 */
    onPhoneCodeOne() {
      if (!this.former_phone.mobile) {
        this.$message.warning(this.$t('请输入手机号'));
        return
      }

      let data = {
        mobile: this.former_phone.mobile,
        type: 6,
        is_test: this.$isDev
      }

      getCode(data).then(res => {
        if (res.code == 1) {
          if (this.$isDev == 1) {
            this.$message.success(this.$t('验证码为：') + res.data.code);
            this.former_phone.code = res.data.code
          } else {
            this.$message.error(res.data.msg);
          }
          this.$refs.phoneCodeOne.start()
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    /**获取手机验证码 */
    onPhoneCodeTwo() {
      if (!this.isVerify) {
        this.$message.warning(this.$t('请先校验手机号'));
        return
      }
      if (!this.new_phone.mobile) {
        this.$message.warning(this.$t('请输入手机号'));
        return
      }

      let data = {
        mobile: this.new_phone.mobile,
        type: 7,
        is_test: this.$isDev
      }

      getCode(data).then(res => {
        if (res.code == 1) {
          if (this.$isDev == 1) {
            this.$message.success(this.$t('验证码为：') + res.data.code);
            this.new_phone.code = res.data.code
          } else {
            this.$message.error(res.data.msg);
          }
          this.$refs.phoneCodeTwo.start()
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    /**修改密码获取手机验证码 */
    onPhoneCode() {
      if (!this.phone_amend.mobile) {
        this.$message.warning(this.$t('请输入手机号'));
        return
      }

      let data = {
        mobile: this.phone_amend.mobile,
        type: 2,
        is_test: this.$isDev
      }

      getCode(data).then(res => {
        if (res.code == 1) {
          if (this.$isDev == 1) {
            this.$message.success(this.$t('验证码为：') + res.data.code);
            this.phone_amend.code = res.data.code
          } else {
            this.$message.error(res.data.msg);
          }
          this.$refs.phoneCode.start()
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
  },
};
</script>

<style scoped lang="scss">
.my-security-setting {
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
  margin: 16px 12px 0;
  border-radius: 8px;
  padding: 24px 24px 90px;
}

.security-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.titile {
  padding: 16px 0 24px;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #EAEBEF;
}

/**标签 */
.tabs {
  display: flex;
  align-items: center;
  margin-top: 24px;
  font-size: 14px;
  margin-bottom: 24px;

  .tabs-box {
    margin-right: 64px;
    cursor: pointer;
    padding-bottom: 11px;
  }

  .tabs-box-ok {
    color: #000;
    padding-bottom: 8px;
    border-bottom: 3px solid #000;
  }
}

/**切换修改密码的方式 */
.tag {
  display: flex;
  align-items: center;

  .tag-box {
    padding: 6px 18px;
    background: #F8F8F8;
    font-size: 14px;
    color: #999999;
    border-radius: 6px;
    margin-right: 24px;
    cursor: pointer;
  }

  .tag-box-ok {
    background: #000;
    color: #FFFFFF;
  }
}

/**修改 */
.amend {
  font-size: 14px;

  .amend-box {
    margin-top: 24px;
    display: flex;
    align-items: center;

    .amend-box-left {
      width: 88px;
    }

    .amend-box-ipt,
    .amend-box-right {
      width: 319px;
      border: 1px solid #BFBFBF;
      padding: 9px 15px;
      box-sizing: border-box;
      border-radius: 4px;
    }

    .amend-box-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .amend-box-btn {
      padding: 6px 12px;
      margin-left: 12px;
      background-color: #000;
      border-radius: 4px;
      color: #FFFFFF;
      cursor: pointer;
      flex-shrink: 0;
    }

    &.amend-box-phone {
      .amend-box-prefix {
        cursor: pointer;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .amend-box-phone-row {
        display: flex;
        align-items: center;
        width: 319px;
      }

      .amend-box-phone-input {
        width: calc(319px - 55px);
        flex: none;
      }
    }
  }
}

/**确定按钮 */
.btn {
  width: 180px;
  height: 42px;
  background: #000;
  color: #FFFFFF;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  line-height: 42px;
  margin-top: 56px;
  margin-left: 80px;
  cursor: pointer;
}

input[type="text"]:disabled {
  background-color: #FFFFFF;
  /* 保持背景色 */
  color: #333333;
}

@media (max-width: 767px) {
  .my-security-setting {
    width: 100%;
    margin: 0;
    padding: 16px 12px 24px;
    box-sizing: border-box;
    box-shadow: none;
    border-radius: 0;
    background: #fff;
  }

  .titile {
    padding: 0 0 16px;
    font-size: 16px;
  }

  .security-content {
    align-items: stretch;
    width: 100%;
  }

  .tabs {
    width: 100%;
    justify-content: space-around;
    margin-top: 16px;
    margin-bottom: 16px;

    .tabs-box {
      margin-right: 0;
      flex: 1;
      text-align: center;
      font-size: 13px;
    }
  }

  .tag {
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;

    .tag-box {
      margin-right: 0;
      flex: 1;
      text-align: center;
      padding: 8px 10px;
      box-sizing: border-box;
    }
  }

  .amend {
    width: 100%;
  }

  .amend .amend-box {
    align-items: flex-start;
    flex-direction: column;
    flex-wrap: nowrap;

    .amend-box-left {
      width: auto;
      margin-bottom: 8px;
    }

    .amend-box-ipt,
    .amend-box-right {
      width: 100%;
    }

    .amend-box-right input {
      flex: 1;
      min-width: 0;
      border: 0;
      padding: 0;
      outline: none;
      font-size: 16px;
      background: transparent;
    }

    &.amend-box-with-btn {
      .amend-box-right {
        width: 100%;
      }

      .amend-box-btn {
        width: 100%;
        margin-left: 0;
        margin-top: 10px;
        text-align: center;
        padding: 10px;
        box-sizing: border-box;
      }
    }

    &.amend-box-phone {
      .amend-box-phone-row {
        width: 100%;
        gap: 8px;
      }

      .amend-box-prefix {
        margin-right: 0;
      }

      .amend-box-phone-input {
        width: auto;
        flex: 1;
        min-width: 0;
      }
    }
  }

  .btn {
    width: 100%;
    margin-left: 0;
    margin-top: 32px;
    height: 44px;
    line-height: 44px;
    border-radius: 6px;
  }

  input[type="text"] {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/my/components/Securitysetting.vue